export default {
  name: 'ShareUserRule'
};